import * as React from 'react';

import { Button } from '@coursera/cds-core';
import type { ButtonName } from '@coursera/event-pulse-types';
import { useTracker } from '@coursera/event-pulse/react';

import type { ProviderName } from 'bundles/third-party-auth/components/AccountLink/types';

import _t from 'i18n!nls/third-party-auth';

type Props = {
  provider: ProviderName;
  linked: boolean;
  disabled: boolean;
  loading: boolean;
  onLink: () => void;
  onDelink: () => void;
};

const linkButtonNameByProvider: Record<ProviderName, ButtonName> = {
  google: 'account_setting_link_google_btn',
  facebook: 'account_setting_link_facebook_btn',
  apple: 'account_setting_link_apple_btn',
};

const delinkButtonNameByProvider: Record<ProviderName, ButtonName> = {
  google: 'account_setting_delink_google_btn',
  facebook: 'account_setting_delink_facebook_btn',
  apple: 'account_setting_delink_apple_btn',
};

const LinkButton = ({ provider, linked, disabled, loading, onLink, onDelink }: Props) => {
  const track = useTracker();

  const handleDelink = () => {
    track('click_button', {
      button: { name: delinkButtonNameByProvider[provider] },
    });
    onDelink();
  };

  const handleLink = () => {
    track('click_button', {
      button: { name: linkButtonNameByProvider[provider] },
    });
    onLink();
  };

  if (linked) {
    return (
      <Button variant="secondary" size="small" disabled={disabled} loading={loading} onClick={handleDelink}>
        {_t('Unlink')}
      </Button>
    );
  }

  return (
    <Button variant="secondary" size="small" disabled={disabled} loading={loading} onClick={handleLink}>
      {_t('Link')}
    </Button>
  );
};

export default LinkButton;
